var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoGreenschools(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "4347.46pt",
    height: "2804.26pt",
    viewBox: "0 0 4347.46 2804.26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    enableBackground: "new"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer-1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("clipPath", {
    id: "cp0"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,0,2804.26)",
    d: "M 0 2804.259 L 4347.46 2804.259 L 4347.46 0 L 0 0 Z "
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp0)"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,792.6922,1867.2847)",
    d: "M 0 0 C 0 -182.463 -147.916 -330.379 -330.379 -330.379 C -512.842 -330.379 -660.758 -182.463 -660.758 0 C -660.758 182.463 -512.842 330.379 -330.379 330.379 C -147.916 330.379 0 182.463 0 0 ",
    fill: "#008249"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,875.7192,1438.5298)",
    d: "M 0 0 L -504.089 -110.931 L -87.997 -487.686 Z ",
    fill: "#008249"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,959.3861,1009.3014)",
    d: "M 0 0 C 0 182.463 147.916 330.379 330.379 330.379 C 512.842 330.379 660.758 182.463 660.758 0 C 660.758 -182.463 512.842 -330.379 330.379 -330.379 C 147.916 -330.379 0 -182.463 0 0 ",
    fill: "#008249"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,977.9814,1820.0569)",
    d: "M 0 0 C 0 182.463 147.916 330.379 330.379 330.379 C 512.842 330.379 660.758 182.463 660.758 0 C 660.758 -182.463 512.842 -330.379 330.379 -330.379 C 147.916 -330.379 0 -182.463 0 0 ",
    fill: "#20ab93"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,107.721,1042.773)",
    d: "M 0 0 C 0 182.463 147.916 330.379 330.379 330.379 C 512.842 330.379 660.758 182.463 660.758 0 C 660.758 -182.463 512.842 -330.379 330.379 -330.379 C 147.916 -330.379 0 -182.463 0 0 ",
    fill: "#8dc144"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,876.3591,1438.0563)",
    d: "M 0 0 L 504.089 110.931 L 87.997 487.686 Z ",
    fill: "#008249"
  })), /*#__PURE__*/React.createElement("text", {
    fill: "#008249",
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 2804.26)",
    fontSize: 951.6862,
    fontFamily: "ReklamaCF"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -1403.9629,
    x: "1757.0264 2211.4566 2522.3724 2885.9166 3239.5633"
  }, "Green"), /*#__PURE__*/React.createElement("tspan", {
    y: -629.2903,
    x: "1757.0264 2159.3995 2502.0064 2901.7147 3258.216 3610.3399 3815.2379"
  }, "Schools"))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoGreenschools);
export default __webpack_public_path__ + "static/media/logo-greenschools.f56817216d57d936bb64a8b1fa34e1e8.svg";
export { ForwardRef as ReactComponent };